import type { GanttLayout } from "@/ds";
import { ROTULO_FECHAMENTO, ROTULO_PLANEJAMENTO } from "@/modules/recursos/simulacao";
import type { CategoriaAlteracao, FiltroComparacao } from "@/modules/recursos/simulacao";
import type { GanttColumn } from "@/shared/components/gantt";

import type { LegendSwatchKind } from "@/shared/components/legend-swatch";

export const COMPARAR_TITULO = "Comparar simulação com o cronograma atual";

export const FILTRO_LABEL: Record<FiltroComparacao, string> = {
  todos: "Todos",
  profissional: "Profissionais",
  fornecedor: "Fornecedores",
  local: "Locais",
};

export const LEGENDA: { kind: LegendSwatchKind; label: string }[] = [
  { kind: "obra", label: "Obra" },
  { kind: "planejamento", label: ROTULO_PLANEJAMENTO },
  { kind: "fechamento", label: ROTULO_FECHAMENTO },
  { kind: "deslocamento", label: "Deslocamento" },
  { kind: "hoje", label: "Hoje" },
];

/** Indicadores do Gantt do Comparar (estado local, sem relação com a preferência do Gantt principal). */
export type IndicadoresComparar = Record<"planejamento" | "obra" | "fechamento", boolean>;

/** O que o modal "Exibir indicadores no Gantt" oferece no Comparar: as três etapas que as barras desenham. */
export const INDICADORES_COMPARAR = [
  { key: "planejamento", label: "Planejamento" },
  { key: "obra", label: "Obra" },
  { key: "fechamento", label: "Fechamento" },
] as const;

/** Todos visíveis ao abrir; a escolha vale só para o Gantt do Comparar. */
export const INDICADORES_COMPARAR_PADRAO: IndicadoresComparar = {
  planejamento: true,
  obra: true,
  fechamento: true,
};

/** Sem etapas de planejamento e fechamento (fornecedor e local), a legenda traz só o que existe. */
export const LEGENDA_SEM_ETAPAS: LegendSwatchKind[] = ["obra", "deslocamento", "hoje"];

export const COLUMNS: GanttColumn[] = [
  { key: "recurso", header: "Recurso", width: "var(--gantt-left)" },
  { key: "versao", header: "Versão", width: "6rem" },
];

export const ROW_HEIGHT = "3.5rem";

/** Barra de 1rem, centrada na linha de 3,5rem (3rem no Figma 9553:41389; o respiro extra é da coluna Recurso). */
export const BARRA_LAYOUT: Partial<GanttLayout> = { barHeightRem: 1, rowPaddingRem: 1.25 };

export const ICONE_CATEGORIA: Record<CategoriaAlteracao, string> = {
  profissional: "pi-users",
  fornecedor: "pi-wrench",
  local: "pi-map-marker",
};
